<template>
  <div>
    <nav class="woocommerce-breadcrumb" itemprop="breadcrumb">
      <a href="/dashboard">Dashboard</a> / <span>Integrations</span> /
      <span> Catalog </span>
    </nav>

    <div class="container-fluid integrations-catalogue-page">
      <h1 class="integrations-catalogue-page__heading">Integrations</h1>
      <p>
        Integrations connect your {{ platformTitle }} account to the apps and tools you already use making your
        marketing much easier.
        <a href="https://intercom.help/snappy-kraken/en/" target="_blank" class="integrations-catalogue-page__link"
          >Learn About Integrations.</a
        >
      </p>
      <img
        v-if="!cards"
        src="/wp-content/themes/snappy-theme/assets/images/loading2.gif"
        class="integrations-catalogue-page__loading"
      />
      <template v-else>
        <template v-if="activeCard">
          <div class="integrations-catalogue-page__subheading">Active Integrations</div>
          <integrations-card
            :available="available"
            :card="activeCard"
            :active="true"
            :connectedCrm="connectedCrm"
            :timezone="timezone"
            maxWidth="336px"
          ></integrations-card>
          <div class="integrations-catalogue-page__subheading">Other Integrations</div>
        </template>
        <div class="integrations-catalogue-page__cards">
          <integrations-card
            v-for="card of inactiveCards"
            :key="card.name"
            :available="available"
            :card="card"
            :connectedCrm="connectedCrm"
            maxWidth="336px"
            :timezone="timezone"
          ></integrations-card>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import IntegrationsCard from '../components/integrations/card/IntegrationsCard.vue';
import {crmsData} from '../components/integrations/crmsData.js';
export default {
  name: 'integrations-catalogue-page',
  components: {
    IntegrationsCard,
  },
  data() {
    return {
      cards: [],
    };
  },
  props: {
    activeCrm: {
      type: String,
    },
    availability: {
      type: Object,
    },
    timezone: {
      type: String,
    },
    platformTitle: {
      type: String,
      required: true,
    },
  },
  computed: {
    connectedCrm() {
      return JSON.parse(this.activeCrm);
    },
    activeCard() {
      return this.cards?.find(card => card.name === this.connectedCrm?.crm_name);
    },
    inactiveCards() {
      return this.cards?.filter(card => card.name !== this.connectedCrm?.crm_name);
    },
    available() {
      return JSON.parse(this.availability);
    },
  },
  created() {
    this.cards = crmsData(this.platformTitle);
  },
};
</script>

<style>
@import '../../sass/templates/integrations/_integrations.scss';
</style>

<style lang="scss" scoped>
@import '../../sass/web/_variables.scss';

.integrations-catalogue-page {
  min-height: calc(100vh - 74px);
  text-align: left;
  padding: 16px;
  background: url('/wp-content/themes/snappy-theme/assets/images/crms/kraken.svg') no-repeat right bottom / 70%;
  @media (min-width: $breakpoint-sm) {
    padding: 24px;
  }
  &__heading {
    font-size: 48px;
    min-height: 56px;
    visibility: visible;
    margin-bottom: 0;
  }
  &__subheading {
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    color: $mine-shaft-color;
    margin: 16px 0;
  }
  &__link {
    color: $half-baked-color;
    text-decoration: underline;
    font-weight: bold;
  }
  &__cards {
    margin: auto;
    justify-content: flex-start;
    gap: 16px;
    display: flex;
    flex-wrap: wrap;
  }
  &__loading {
    display: block;
    margin: 80px auto;
    width: 150px;
  }
}
</style>
